import { VIDEO_OPTIONS } from './component-lib.esm2.js';
import { PLATFORM_OPTIONS } from './component-lib.esm3.js';
import { FORM_OPTIONS } from './component-lib.esm4.js';
function getEmbedType(url) {
  if (!url) return undefined;
  return [...PLATFORM_OPTIONS, ...VIDEO_OPTIONS, ...FORM_OPTIONS].find(option => {
    for (let i = 0; i < option.urlPatterns.length; i++) {
      const pattern = option.urlPatterns[i];
      if (pattern.test(url)) return true;
    }
    return false;
  });
}
export { getEmbedType };